import { render, staticRenderFns } from "./NotFoundProblem.vue?vue&type=template&id=e5e07910&"
import script from "./NotFoundProblem.vue?vue&type=script&lang=js&"
export * from "./NotFoundProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports